import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { generateUUID } from './meta-utils';
import formInteractionEvent from './form-interaction-event';
import logPageView from './log-page-view';
import getPageViewId from './get-page-view-id';
import elementInteraction from './element-interaction';
import errorEvent from './error-event';
import customEvent from './custom-event';
import setProductImpressionMeta from './product-impression';
import reducer from './reducer';
import * as actions from './actions';
import * as Components from './components';
/**
 * Connects to NWA's event center to log the page view event.
 *
 * @param {String} path The path of the route that needs to be logged as a page view.
 */

export { logPageView };
/**
 * Connects to NWA's event center to log the form input changed event.
 *
 * @param info The tracking info to be sent to the NWA api.
 *
 * @param info.formName The name of the form. Should be independent from actual page,
 * and drawn from the form element.
 * @param info.inputType The type of input, as specified by the HTML input element.
 * @param info.fieldName Human-readable(-ish) name of a field, i.e. yearly-income.
 * Should be drawn from the input's label element.
 * @param info.fieldValue = The value of the input. It is not required,
 * as the value may be sensitive.
 * DO NOT INCLUDE FOR NOW!
 *
 * @see https://nerdwallet.atlassian.net/wiki/display/ENG/Event+Schemas#EventSchemas-FormInputChangedEvent
 */

export var formInputChanged = formInteractionEvent.onInputChanged;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_OPEN.
 *
 * Invoked when a modal dialog is opened.
 */

export var formOpen = formInteractionEvent.onFormOpen;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_SUBMIT
 *
 * Invoked when a form/dialog is completed.
 */

export var formSubmit = formInteractionEvent.onFormSubmit;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_CANCEL
 *
 */

export var formCancel = formInteractionEvent.onFormCancel;
/**
 * A flavor of the form interaction event (named formInputChanged for legacy reasons)
 * but with action enum FORM_MOVE_TO_PAGE
 */

export var formMoveToPage = formInteractionEvent.onFormMoveToPage;
/**
 * Get current page's page view id from NWA
 */

export { getPageViewId };
/**
 * Convenience wrapper around customEvent to fire Element Interaction Events.
 * @property {object} elementInteractionHeader - has fields elementName and interactionType.
 */

export { elementInteraction };
/**
 * Convenience wrapper around customEvent to fire Error Events.
 * @propery {object} options - has fields message, code, type, and additionalData
 */

export { errorEvent };
/**
 * Connects to NWA's event center to log any event manually.
 *
 * @param eventName - The name of the event schema (E.g. PRODUCT_INTERACTION_EVENT)
 * @param endpoint - The logger endpoint to hit (E.g. product_interaction_event)
 * @param info - The data object to pass along the API
 *
 */

export { customEvent };
/**
 * Sets up the metadata for product impressions to be fired as defined by your app requirements.
 *
 * @param {Object} loggerData The schema object metadata as defined in your event schema.
 */

export { setProductImpressionMeta };
/**
 * Generates a UUID using NWA for use in custom tracking. No params.
 *
 */

export { generateUUID };
/*
 * Export reducers and actions for impression events
 */

export { reducer };
export { actions };
/*
 *  Export components for impressions/clicks
 */

export * from './components';
export default _objectSpread({
  logPageView: logPageView,
  formInputChanged: formInputChanged,
  formOpen: formOpen,
  formSubmit: formSubmit,
  formCancel: formCancel,
  formMoveToPage: formMoveToPage,
  getPageViewId: getPageViewId,
  elementInteraction: elementInteraction,
  errorEvent: errorEvent,
  customEvent: customEvent,
  setProductImpressionMeta: setProductImpressionMeta,
  generateUUID: generateUUID,
  reducer: reducer,
  actions: actions
}, Components);